/* 获取首页轮播图列表, 轮播图尺寸 1903 * 975*/
import { get_url_deal } from '@/utils/commons'
import request from '@/utils/request'

/* ---------------------------------------------------获取首页页头数据---------------------------------------------------*/
export function get_head_data(data) {
  const url = get_url_deal('index/selectIndexHead.json', data)
  return request.get(url)
}

/* ---------------------------------------------------获取首页页脚数据---------------------------------------------------*/
export function get_bottom_data(data) {
  const url = get_url_deal('index/selectIndexBottom.json', data)
  return request.get(url)
}

/* ---------------------------------------------------获取首页轮播图数据---------------------------------------------------*/
export function get_carousel_data(data) {
  const url = get_url_deal('index/selectIndexCarousel.json', data)
  return request.get(url)
}

/* ---------------------------------------------------获取首页主体数据, 图片尺寸 320 * 223---------------------------------------------------*/
export function get_main_data(data) {
  const url = get_url_deal('index/selectIndexMain.json', data)
  return request.get(url)
}

export function showHtmlGray() {
  return request.get('index/showHtmlGray.json')
}
